import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';
import {
    GetTemplatesNamesAndIdsDto,
    GetTranslationsDto,
    IGroupEntityDTO,
    ITemplateEntityDTO,
    TemplateType,
    UpdateTranslationsDto,
} from '@modeso/types__aumico-lib-templates-be';
import { Observable } from 'rxjs';
import { IFinancialLineItem } from '../interfaces/settings.interface';
export interface ITemplatesProvider {
    dispatchGroups(): void;
    getGroups$(): Observable<IGroupEntityDTO[]>;
    getDefaultGroups$(): Observable<Map<string, IGroupEntityDTO>>;
    getActiveGroup$(): Observable<IGroupEntityDTO>;
    setActiveGroup(groupId: string): void;
    removeActiveGroup(): void;
    createGroup(groupToBeCreated: IGroupEntityDTO): void;
    updateGroup(groupToBeUpdated: IGroupEntityDTO, groupId: string): void;
    deleteGroup(groupId: string): void;
    selectGroups(groupsIds: string[]): void;
    deselectGroup(groupId: string): void;
    getGroupsResponse$(): Observable<any>;
    removeGroupsResponse(): void;
    getGroupsError$(): Observable<any>;
    removeGroupsError(): void;
    getGroupNameExists$(name: string, groupId: string): Observable<boolean>;
    getTranslations$(): Observable<GetTranslationsDto>;
    dispatchGetTranslations(locales: string[], untranslatedOnly: boolean): void;
    dispatchUpdateTranslations(translations: UpdateTranslationsDto): void;
    dispatchTemplates(): void;
    getTemplates$(): Observable<ITemplateEntityDTO[]>;
    getActiveTemplate$(): Observable<ITemplateEntityDTO>;
    setActiveTemplate(templateId: string): void;
    getActiveTemplateType$(): Observable<TemplateType>;
    setActiveTemplateType(templateType: TemplateType): void;
    removeActiveTemplate(): void;
    createTemplate(templateToBeCreated: ITemplateEntityDTO): void;
    updateTemplate(templateTobeUpdated: ITemplateEntityDTO, templateId: string): void;
    getTemplatesResponse$(): Observable<any>;
    removeTemplatesResponse(): void;
    getTemplatesError$(): Observable<any>;
    removeTemplatesError(): void;
    getTemplateNameExists$(name: string, templateId: string): Observable<boolean>;
    getTemplateAccountBasisAndLegalFormExists$(
        accountBasis: string,
        legalForm: string,
        type: string,
        templateId: string,
    ): Observable<boolean>;
    setSubtotalsNames(subtotalsNames: string[]): void;
    removeSubtotalName(subtotalName: string): void;
    getSubtotalNameExists$(name: string): Observable<boolean>;
    setFinancialLineItems(financialLineItems: IFinancialLineItem[]): void;
    getFinancialLineItems$(): Observable<IFinancialLineItem[]>;
    selectFinancialLineItems(financialLineItems: string[]): void;
    deselectFinancialLineItem(financialLineItem: string): void;
    getCashAndProfitOptions$(): Observable<string[]>;
    getAllTemplatesNamesAndIdsByTemplateType$: (templateType: TemplateType) => Observable<GetTemplatesNamesAndIdsDto[]>;
    dispatchGetAllTemplatesNamesAndIdsByTemplateType: (templateType: TemplateType) => void;
    setAllAccountsFromExcel: (accounts: IAccount[]) => void;
    addAccountToAllAccountsExcel: (account: IAccount) => void;
}
